<template>
<button :disabled="disabled" class="cc-btn"
@click="handleClick" 
:style="styleObject"
:class="[size ? 'cc-btn-' + size : '']"
>
<slot>按钮</slot>
</button>
</template>

<script>
export default{
    name:''
    ,props:{
        type:String
        ,color:String
        ,height:Number
        ,width:Number
        ,styles:{
            type:Object
            ,default:()=>{}
        }//自定义样式
        ,disabled:{
            type:Boolean
            ,default:false
        }
        ,size:String//large,small
    }
    ,computed:{
        styleObject(){
            let _style={};
            if (this.height) {
                _style.height = this.height + 'px';
                _style.lineHeight = this.height-12 + 'px';
            }
            if(this.width){
                _style.width = this.width + 'px';
            }
            if(this.color){
                _style.backgroundColor = '#'+this.color;
                _style.borderColor = '#'+ this.color;
            }else{
                if(this.type){
                    _style.backgroundColor = '#' + this.colorConfig[this.type];
                    _style.borderColor = '#' + this.colorConfig[this.type];
                }
            }
            return _style;
            // if(Com.isEmptyObject(this.style)){
            //     return _style;
            // }else{
            //     return Com.cloneObjects(_style,this.style); 
            // }
        }
    }
    ,data(){
        return {
           colorConfig:{
               gray:'758497'
               ,primary:'3b5d8b'
               ,info:'3bb5e4'
               ,confirm:'59738c'
               ,cancel:'9fa4a9'
           }
        }
    }
    ,methods:{
        handleClick(evt){
            this.$emit('click',evt);
        }
    }
}
    
</script>

<style scoped>
    .cc-btn{
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: initial;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        color:#fff;
        padding: 5px 0;
        font-size: 12px;
        width:84px;
        margin:0 6px;
        line-height: initial;
    }
    .cc-btn-small{
        width:65px;
        padding:3px 0;
    }
    .cc-btn-large{
        padding:5px 10px;
        width:initial;
    }
    .cc-btn:hover{
        opacity:0.8
    }
    .cc-btn:disabled{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// components/Cc-Button/Button.vue